import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import Typography from '@mui/material/Typography';

const TitleTypographyQuote = styled(Typography)`
font: 700 14px/1.71 Merriweather;
background-color: #fcfcfc;
  color: #737373;
  font-size: 18px;
  letter-spacing: 2px;
  padding: 0 20px;
  position: absolute;
  right: 50%;
  /* top: 4px; */
  transform: translate(50%, -120%);
  z-index: 1;
`;
const QuoteContainer = styled.div`
  margin-top: 20px;
   /* Yellow border color */
  padding: 20px; /* Adjust padding as needed */
  text-align: center;
  max-width: 800px; 
  /* Set a maximum width if desired */
  margin: 0 auto; /* Center the container horizontally */
  margin-bottom: 22rem;
`;

const InnerContainer = styled.div`
border: 6px solid #ece5c0;
max-width: 100%; 
padding: 20px; 
`;

const ContentTypography = styled(Typography)`
  font-size: 16px;
  color: #333; /* Adjust color as needed */
  margin-bottom: 10px;
`;

const AuthorTypography = styled(Typography)`
  font-style: italic;
  color: #555; /* Adjust color as needed */
`;

const QuoteOfTheDay = () => {
  const [quote, setQuote] = useState({});

  useEffect(() => {
    const fetchQuoteOfTheDay = async () => {
      try {
       // const response = await axios.get('https://api.quotable.io/random');
        setQuote({"author":"Friedrich Schiller", content:"Art is the right hand of Nature. The latter has only given us being, the former has made us men."});
      } catch (error) {
        console.error('Error fetching quote:', error);
      }
    };

    fetchQuoteOfTheDay();
  }, []);

  return (
    <QuoteContainer>
        <InnerContainer>
        <TitleTypographyQuote> Quote of the Day</TitleTypographyQuote>
       <ContentTypography>{quote.content}</ContentTypography>
        <AuthorTypography>- {quote.author}</AuthorTypography>
        </InnerContainer>
      
    </QuoteContainer>
  );
};

export default QuoteOfTheDay;
